import React, { FC } from "react";
import styled from "styled-components";

type ModalProps = {
  content: string;
  onClose: () => void;
};

const Modal: FC<ModalProps> = ({ content, onClose }) => {
  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>×</CloseButton>
        <ModalBody dangerouslySetInnerHTML={{ __html: content.replace(/\n/g, "<br />") }} />
      </ModalContent>
    </ModalOverlay>
  );
};

export default Modal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  width: 80%;
  max-width: 600px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.5em;
  cursor: pointer;
`;

const ModalBody = styled.div`
  padding: 20px;
  font-size: 1em;
  color: #333;
  img {
    max-width: 100%;
    height: auto;
    border-radius: 10px;
  }
`;
